//libs
import React, {useRef, useState} from 'react';
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";

// components
import Switch from "react-switch";

const ManageCardForm = (props) => {

    const { cardData: {cardHolder, useMiscellaneous, useOdometer, dayCreditLimit, cardNumber, nip}, subAccountType } = props;
    const { t, i18n } = useTranslation();
	const [nipTouched, setNipTouched] = useState(false);
	const [showErrorOnChange, setShowErrorOnChange] = useState(false);

	const { register, handleSubmit, watch, control, formState: { errors } } = useForm({defaultValues:{
            cardNumber: cardNumber,
            useMiscellaneous: useMiscellaneous,
            useOdometer: useOdometer,
        }});


    const pin = useRef({});
    pin.current = watch("nip", "");

    const onSubmit = async data => {
		if (!data.nip && !data.nipConfirm) {
			data.nip = nip;
			data.nipConfirm = nip;
		}
        props.formSubmit(data);
    };


    const displayErrors = (fieldname) => {
        let html = "";

        if(errors[fieldname]){
            let errorMessage = "";
            if(errors[fieldname].message){
                errorMessage = errors[fieldname].message;
			} else {
				switch(errors[fieldname].type){
                    case("required"): errorMessage = t("errors.fieldrequired"); break;
                    case("min"): errorMessage = t("errors.minval"); break;
                    case("max"): errorMessage = `${t("errors.maxval_credit_limit")} ${dayCreditLimit}. ${t("errors.maxval_credit_limit_end")}`; break;
					default: errorMessage = t("errors.error"); break;
                }
            }
            html = (<p className="error">{ errorMessage }</p>)
        }

        return html;
    }




    return (
        <form className="cardmanager__form form" onSubmit={handleSubmit(onSubmit)} method="post">
            <fieldset className="fieldset">
                <h4 className="headline headline--section">
                    { t('account.cards.management.form.info_title') }
                </h4>
                <div className="row mb-4">
                    <div className="col col-12 col-md-6">
                        <div className={`input-field${errors.cardOwner ? ' input-field--error' : ''}`}>
                            <label htmlFor="txt_cardholder" className="label">
                                { t('account.cards.management.form.cardholder_name_label') }
                            </label>
                            <div className="control">
                                <input type="text" name="cardholder" id="txt_cardholder" {...register("cardOwner", {required: true}) } defaultValue={cardHolder} />
                                { displayErrors("cardOwner") }
                            </div>
                        </div>
                    </div>
                    <div className="col col-12 col-md-6">
                        <div className={`input-field${errors.numDailyLimit ? ' input-field--error' : ''}`}>
                            <label htmlFor="num_daily_limit" className="label">
                                { t('account.cards.management.form.daily_limit_label') }
                            </label>
                            <div className="control">
                                <input id="num_daily_limit" name="daily-limit" type="number" step="1"
									   list="defaultNumbers" {...register("numDailyLimit", {min: 0, max: dayCreditLimit, required: true,
									onChange : (v)=> parseInt(v.target.value) > dayCreditLimit ?
										setShowErrorOnChange(true) : setShowErrorOnChange(false) })
								} defaultValue={dayCreditLimit} />
                                { displayErrors("numDailyLimit") }
                                { showErrorOnChange ? <p className="error">{ t("errors.creditover") }</p> : '' }
                            </div>
                        </div>
                        <datalist id="defaultNumbers">
                            <option value="100"></option>
                            <option value="200"></option>
                            <option value="500"></option>
                            <option value="1000"></option>
                            <option value="10000"></option>
                        </datalist>
                    </div>
                </div>
                {subAccountType == 'K' &&
                    <div className={`input-field toggle${errors.useOdometer ? ' input-field--error' : ''}`}>
                        <label htmlFor="chk_odometer" className="toggle__wrapper label">
                            <div className="control">
                                <Controller
                                    control={control}
                                    name="useOdometer"
                                    render={({
                                                 field: {onChange, onBlur, value, name, ref},
                                                 fieldState: {invalid, isTouched, isDirty, error},
                                                 formState,
                                             }) => (
                                        <Switch
                                            onChange={onChange}
                                            checked={value}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            height={24}
                                            width={46}
                                            onColor="#55B545"
                                            inputRef={ref}
                                            id="chk_odometer"
                                        />
                                    )}
                                />
                                <span className="toggle__label">
                                    {t('account.cards.management.form.odometer_toggle')}
                                </span>
                            </div>
                            {displayErrors("useOdometer")}
                        </label>
                    </div>
                }
                {subAccountType == 'K' &&
                    <div className={`input-field toggle${errors.useMiscellaneous ? ' input-field--error' : ''}`}>
                        <label htmlFor="chk_misc" className="toggle__wrapper label">
                            <span className="control">
                                <Controller
                                    control={control}
                                    name="useMiscellaneous"
                                    render={({
                                                 field: {onChange, onBlur, value, name, ref},
                                                 fieldState: {invalid, isTouched, isDirty, error},
                                                 formState,
                                             }) => (
                                        <Switch
                                            onChange={onChange}
                                            checked={value}
                                            uncheckedIcon={false}
                                            checkedIcon={false}
                                            height={24}
                                            width={46}
                                            onColor="#55B545"
                                            inputRef={ref}
                                            id="chk_misc"
                                        />
                                    )}
                                />
                                <span className="toggle__label">
                                    {t('account.cards.management.form.misc_toggle')}
                                </span>
                            </span>
                            {displayErrors("useOdometer")}
                        </label>
                    </div>
                }
            </fieldset>


            {subAccountType == 'K' &&
                <fieldset className="fieldset">
                    <h4 className="headline headline--section">
                        { t('account.cards.management.form.pin_title') }
                    </h4>
                    <div className="row">
                        <div className="col-md-6">
                            <div className={`input-field switch${errors.nip ? ' input-field--error' : ''}`}>
                                <label htmlFor="txt_pin" className="label">
                                    { t('account.cards.management.form.pin_label') }
                                </label>
                                <div className="control">
                                    <input type="password"
                                           name="pin"
                                           id="txt_pin"
                                           {...register(
                                               "nip",
                                               {
												   onChange: () => setNipTouched(true),
												   pattern:{
                                                       value: /^(0|[1-9]\d*)(\.\d+)?$/,
                                                       message: t("errors.numbersonly")
                                                   },
                                                   minLength: {
                                                       value: 4,
                                                       message: t("errors.minlength") + " 4"
                                                   },
                                                   maxLength: {
                                                       value: 4,
                                                       message: t("errors.maxlength") + " 4"
                                                   },
											   }
                                           )} />
                                    { displayErrors("nip") }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={`input-field switch${errors.nipConfirm ? ' input-field--error' : ''}`}>
                                <label htmlFor="txt_pin_confirm" className="label">
                                    { t('account.cards.management.form.pin_confirm_label') }
                                </label>
                                <div className="control">
                                    <input type="password"
                                           name="pin_confirm"
                                           id="txt_pin_confirm"
										   {...register(
                                               "nipConfirm",
                                               {
												   onChange: () => setNipTouched(true),
												   pattern:{
                                                       value: /^(0|[1-9]\d*)(\.\d+)?$/,
                                                       message: t("errors.numbersonly")
                                                   },
                                                   minLength: {
                                                       value: 4,
                                                       message: t("errors.minlength") + " 4"
                                                   },
                                                   maxLength: {
                                                       value: 4,
                                                       message: t("errors.maxlength") + " 4"
                                                   },
                                                   validate: value => nipTouched ? value === pin.current || t("errors.pinsnotmatch") : true,
                                               }
                                           )} />
                                    { displayErrors("nipConfirm") }
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            }

            <fieldset className="fieldset form__actions">
                <button className="btn btn--outline btn--outline--gray action" onClick={props.closeModal}>
                        <span className="btn__text">
                            { t('account.cards.management.buttons.cancel') }
                        </span>
                </button>
                <button type="submit" className="btn btn--raised btn--raised--red action">
                    <span className="btn__text">
                        { t('account.cards.management.buttons.submit') }
                    </span>
                </button>
            </fieldset>
        </form>
    );
};

export default ManageCardForm;
